import { InputContainer } from "./style";

export const BaseInputs = ({ value, ...restProps }) => {
  return <InputContainer value={value} {...restProps} />;
};
